import { useEffect, useState } from "react";
import { FaDiscord } from "react-icons/fa";

// Invito pubblico del server Discord di Neko-CLI.
// Se in futuro cambi invito, basta aggiornare questa costante.
const INVITE_CODE = "awyRzJmsK";
const INVITE_URL = "https://discord.gg/5Vax43BYd";

export default function DiscordWidget({ className = "" }) {
  const [data, setData] = useState(null);
  const [error, setError] = useState(false);

  useEffect(() => {
    let cancelled = false;

    fetch(`https://discord.com/api/v10/invites/${INVITE_CODE}?with_counts=true&with_expiration=true`)
      .then((res) => {
        if (!res.ok) throw new Error("invite fetch failed");
        return res.json();
      })
      .then((json) => !cancelled && setData(json))
      .catch(() => !cancelled && setError(true));

    return () => {
      cancelled = true;
    };
  }, []);

  const guild = data?.guild;
  const iconUrl = guild?.icon
    ? `https://cdn.discordapp.com/icons/${guild.id}/${guild.icon}.png?size=128`
    : null;

  return (
    <div
      className={`w-full max-w-md rounded-xl bg-black/20 border border-white/10 px-5 py-4 flex items-center gap-4 ${className}`}
    >
      <div className="shrink-0">
        {iconUrl ? (
          <img
            src={iconUrl}
            alt={guild?.name || "Neko-CLI Discord"}
            className="w-14 h-14 rounded-full border border-white/10"
            loading="lazy"
          />
        ) : (
          <div className="w-14 h-14 rounded-full bg-primary-500/20 flex items-center justify-center">
            <FaDiscord size={28} className="text-primary-400" />
          </div>
        )}
      </div>

      <div className="flex-1 min-w-0">
        <div className="flex items-center gap-2">
          <p className="text-pride-pink font-semibold truncate">
            {guild?.name || "Neko-CLI"}
          </p>
          <span className="text-[10px] uppercase tracking-wide bg-primary-500/20 text-primary-300 px-2 py-0.5 rounded-full shrink-0">
            Secondary support
          </span>
        </div>

        {!error && data ? (
          <p className="text-xs text-primary-400 mt-0.5">
            <span className="inline-block w-2 h-2 rounded-full bg-green-500 mr-1 align-middle" />
            {data.approximate_presence_count ?? 0} online ·{" "}
            {data.approximate_member_count ?? 0} members
          </p>
        ) : (
          <p className="text-xs text-primary-500 mt-0.5">
            Chat with us and the community on Discord
          </p>
        )}
      </div>

      <a
        href={INVITE_URL}
        target="_blank"
        rel="noopener noreferrer"
        className="shrink-0 inline-flex items-center gap-2 bg-[#5865F2] hover:bg-[#4752C4] transition-colors duration-200 text-pride-pink text-sm font-medium px-3 py-2 rounded-lg"
        aria-label="Join the Neko-CLI Discord"
      >
        <FaDiscord size={16} />
        Join
      </a>
    </div>
  );
}
